import React from "react";
import { VendorDto } from "../../../../../src/js/common/service/server/dto/VendorDto";
import { UUIDString } from "../../../../../src/js/common/service/server/Types";
import { useDefaultVendors } from "../../../../../src/js/polaris/util/resources/vendorUtils";
import { DEFAULT_DATA_RECIPIENT_NAMES } from "../../../../../src/js/polaris/components/VendorSearchContents";
import { QuestionHeading } from "../../../../../src/js/polaris/components/vendor/QuestionHeading";
import { RowVendorTile } from "../../../../../src/js/polaris/pages/stay-compliant/data-recipients/RowVendorTile";
import { VENDOR_KEY_TRUEVAULT } from "../../../../../src/js/polaris/types/Vendor";

type CommonDataRecipientsProps = {
  allVendors: VendorDto[];
  addedVendors: Set<UUIDString>;
  pendingVendor?: UUIDString;
  handleAddVendor: (v: UUIDString) => void;
};

export const CommonDataRecipients: React.FC<CommonDataRecipientsProps> = ({
  allVendors,
  addedVendors,
  pendingVendor,
  handleAddVendor,
}) => {
  const defaultVendors = useDefaultVendors(allVendors, DEFAULT_DATA_RECIPIENT_NAMES);

  return (
    <>
      <QuestionHeading question="Do you use any of these common vendors?" />

      <div className="vendor_grid">
        {defaultVendors.map((v) => {
          const isAdded = addedVendors.has(v.id);
          return (
            <RowVendorTile
              key={v.id}
              name={v.name}
              category={v.category}
              logoUrl={v.logoUrl}
              vendor={v}
              pending={pendingVendor == v.id}
              disabled={Boolean(pendingVendor) || vendorDisabled(v, isAdded)}
              added={isAdded}
              selected={isAdded}
              handleAddVendor={() => handleAddVendor(v.id)}
            />
          );
        })}
      </div>
    </>
  );
};

export const vendorDisabled = (v: VendorDto, isAdded: boolean): boolean => {
  return v.vendorKey == VENDOR_KEY_TRUEVAULT && isAdded;
};
